import React, { FC } from 'react';
import { TimelineItemsList } from './TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import TimelineComponent from '@components/machines/components/timeline';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { useTrackMachineTimelineOpened } from './hooks/useTrackMachineTimelineOpened';
import { ALL_MACHINES } from '@helpers';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface TimelineProps extends NavigationProps {}

const Timeline: FC<TimelineProps> = ({ lg }) => {
  useTrackMachineTimelineOpened();

  const selectedItem = useSelector(selectSelectedItem);
  const id = selectedItem?.id;

  const isAllSelected = id === ALL_MACHINES;

  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
    >
      {isAllSelected ? <MultiMachineTimeline withScroll={false} fullScreen={false} /> : <TimelineComponent fullScreen={false} />}
    </MachinesProvider>
  );
};

export { Timeline };
